














import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState } from "vuex";

// Vue components
import NavigationDrawer from "./Components/NavigationDrawer.vue";
import AppBar from "./Components/AppBar.vue";
import Footer from "./Components/Footer.vue";
import AlertBanners from "./Components/AlertBanners.vue";

export default Vue.extend({
    components: {
        NavigationDrawer,
        AppBar,
        AlertBanners,
        Footer,
    },
    computed: {
        ...mapState({ tvMode: (s: RootState) => s.application.tvMode, loomisStyle: (s: RootState) => s.application.startupData.brandedMode }),

        currentRoute() {
            return this.$route;
        },
        vMainStyle() {
            if (this.loomisStyle && !this.tvMode) {
                if (this.$vuetify.breakpoint.smAndUp) return "padding-top: 150px";
                else return "padding-top: 220px";
            }
            return "";
        },
    },
});
